import * as types from "./types";
import { combineReducers } from "redux";

/*----------------------------------------------------------------------------*/

function dataSaved(state = { status: false, msg: "" }, { type, payload }) {
  return type === types.DATA_SAVED
    ? payload
    : type === types.RESET_DATA_SAVED
      ? { status: false, msg: "" }
      : state;
}

function personasContacto(state = [], { type, payload }) {
  return type === types.ADDED_PERSONAS_CONTACTO
    ? [
        ...state.filter(
          ({ id, idColegio }) =>
            id !== payload.id && idColegio === payload.idColegio
        ),
        payload
      ]
    : type === types.REMOVED_PERSONAS_CONTACTO
      ? state.filter(({ id }) => id !== payload.id)
      : type === types.CHANGED_PERSONAS_CONTACTO
        ? state.map(item => (item.id === payload.id ? payload : item))
        : type === types.LIMPIAR_PERSONAS_CONTACTO
          ? []
          : state;
}

/*----------------------------------------------------------------------------*/

const reducer = combineReducers({
  dataSaved,
  personasContacto
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/ventasContactos/reducers.js